import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon35: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#4775FF"
        d="M9.499 0C13.089 0 16 2.901 16 6.48l.001 1.556a3.5 3.5 0 0 1-.135 6.945 5.33 5.33 0 0 1-3.365 3.824v.695a.5.5 0 0 1-.5.5H9.254a1.75 1.75 0 1 1 0-3.5h2.747a.5.5 0 0 1 .5.5v.724A4.338 4.338 0 0 0 15 13.798V6.48C15 3.454 12.538 1 9.499 1 6.462 1 4 3.454 4 6.48v8.02a.5.5 0 0 1-.5.5l-.192-.005A3.5 3.5 0 0 1 3 8.035V6.48C3 2.901 5.91 0 9.499 0Zm2.002 17.5H9.254a.75.75 0 1 0 0 1.5h2.247v-1.5Zm-8.5-8.45a2.5 2.5 0 0 0 0 4.9v-4.9ZM16 9.05v4.9a2.502 2.502 0 0 0 0-4.9Z"
      />
    </Svg>
  )
}
